/* eslint-disable ember/no-computed-properties-in-native-classes */
import BaseEnrolmentUnenrolment from 'linced-app/models/enrolments/base-enrolment-unenrolment';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';

// Proto: enrolments.Unenrolment.
export default class Unenrolment extends BaseEnrolmentUnenrolment {
  declare [Type]: 'enrolments/unenrolment';

  @computed('type')
  get statusIcon() {
    switch (this.type) {
      case 'I':
      case 'J':
        return 'check-circle';
    }
    return 'warning';
  }

  @computed('type')
  get statusClass() {
    switch (this.type) {
      case 'I':
      case 'J':
        return 'green';
    }
    return 'warning';
  }
}
